import { IClientVarsService } from '../interfaces/client-vars-service.interface';
import { ISlideAppService } from '../interfaces/slide-app-service.interface';
import { ISlideInitialData, SlideInitialDataType } from '../interfaces/slide-initial-data-service.interface';
import { ILogger } from '../slide-data-services.core';
import { IPresentationStoreService } from '../interfaces/presentation-service.interface';
import { IContentStatusManager } from '../factory/content-status-manager-factory';
import { AppServiceProvider } from '@src/slide/application/app-service-provider';
import eventBus, { EventKeys } from '@src/slide/infrastructure/module/independent/event-emitter/instance';

export abstract class BaseSlideAppService implements ISlideAppService {
    public static namespace = 'SlideAppService';
    public static voidMethods = [];
    private isEmitReady = false;

    public constructor(
        protected logger: ILogger,
        protected presentationStoreService: IPresentationStoreService,
        protected clientVarsService: IClientVarsService,
        protected contentStatusManager: IContentStatusManager,
    ) {
        this.init();
    }

    public onReady(callback: () => void): void {
        AppServiceProvider.getInstance().waitForReady(() => {
            if (!this.isEmitReady) {
                // 有一些基建需要知道此时机，用事件派发
                this.isEmitReady = true;
                eventBus.emit(EventKeys.SLIDE_APP_READY, {
                    clientVars: this.clientVarsService.getClientVars(),
                });
            }
            callback();
        });
    }

    public onReadyPromise(): Promise<void> {
        return new Promise(this.onReady.bind(this));
    }

    public getSnapshotData(): ISlideInitialData {
        return {
            type: SlideInitialDataType.PresentationData,
            data: this.presentationStoreService.getPresentation().getCloneData(),
        };
    }

    public transaction(action: () => void) {
        if (!this.presentationStoreService?.getTransaction?.()) {
            return action();
        }

        return this.presentationStoreService.getTransaction()(action);
    }

    public getSlideCount() {
        return this.presentationStoreService.getPresentation()?.slideList.length;
    }

    protected checkSlideAppStatus(): Error | undefined {
        return this.contentStatusManager.getCorruptedError();
    }

    protected abstract init(): void;
}
